import queryString from 'query-string'
// Constants
import {DEFAULT_SEARCH_PARAMS} from '../constants'
import {ISearchParams} from '../store/ProductStore'
import algoliasearchHelper from 'algoliasearch-helper'
import { ExtendedRenderingContent } from '../types/algolia'

const PARSE_OPTIONS = {
  parseBooleans: true,
}

/**
 * Encode's the provided search parameters object, paying special attention to ensure
 * that the child `refine` object is alway encoded correctly.
 */

export const stringifySearchParams = (searchParamsObj: ISearchParams<Record<string, string>>) => {
  const searchParamsObjCopy: ISearchParams = {...searchParamsObj, refine: []}

  // "stringify" the nested refinements
  if (searchParamsObj?.refine)
    searchParamsObjCopy.refine = Object.keys(searchParamsObj?.refine).map((key) =>
      queryString.stringify(
        {[key]: searchParamsObj?.refine?.[key]},
        {
          arrayFormat: 'separator',
          arrayFormatSeparator: '|',
          encode: false,
        }
      )
    )

  // "stringify" the entire object
  return queryString.stringify(searchParamsObjCopy)
}

/**
 * Decode's the provided query string representation of a search parameter object, paying
 * special attention to also decode the 'refine' object.
 */
export const parseSearchParams = (searchParamsStr: string, parseRefine = true) => {
  const params: ISearchParams<string[]> = queryString.parse(searchParamsStr, PARSE_OPTIONS) as any

  // Ensure the refinments is an array (make it easier to manipulate).
  params.refine = Array.isArray(params.refine)
    ? params.refine
    : params.refine
    ? [params.refine]
    : []

  // Parse the nested refinement entries.
  if (parseRefine && Array.isArray(params.refine)) {
    params.refine = params.refine.reduce((acc, curr) => {
      return {
        ...acc,
        ...queryString.parse(curr, {
          ...PARSE_OPTIONS,
          arrayFormat: 'separator',
          arrayFormatSeparator: '|',
        }),
      }
    }, params.refine)
  }

  return params
}

export function queryToProductSearch(query: string) {
  return {
    ...DEFAULT_SEARCH_PARAMS,
    ...parseSearchParams(query.substring(1)),
  }
}

/**
 * Takes a results object, and returns the url redirect if there is one available
 * Extended the type definition to include the redirect property
 * @TODO This is worth checking after the Algolia upgrade as we may have access to the redirect
 * on the newer version
 * @param results - the instant search results
 * @returns a string for the redirect if there is one
 */

export function getRedirectURL(results: algoliasearchHelper.SearchResults<any> & { renderingContent?: ExtendedRenderingContent }) {
  if (!results) return
  const url = results?.renderingContent?.redirect?.url
  
  if (url) {
    return url
  }
}
